import * as constants from '../constants';

const INITIAL_STATE = {
    items: [],
    page: 1,
    count: 0,
    loading: false,
    error: null,
    invalid: false,
    filterText: '',
    sortBy: '',
    uploading: false,
    uploadError: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.MEDIA_LIST_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.MEDIA_LIST_SUCCESS:
            return Object.assign({}, state, {loading: false, items: action.payload.data.items, count: action.payload.data.count, error: null, invalid: false});
        case constants.MEDIA_LIST_FAILURE:
            return Object.assign({}, state, {loading: false, items: [], count: 0, error: action.payload.error});
        case constants.MEDIA_LIST_CHANGE_PAGE:
            return Object.assign({}, state, {page: action.payload.page});
        case constants.MEDIA_LIST_CHANGE_FILTER:
            return Object.assign({}, state, {filterText: action.payload.filterText, sortBy: action.payload.sortBy});
        case constants.MEDIA_UPLOAD_REQUESTED:
            return Object.assign({}, state, {uploading: true, uploadError: null});
        case constants.MEDIA_UPLOAD_SUCCESS:
            return Object.assign({}, state, {uploading: false, invalid: true});
        case constants.MEDIA_UPLOAD_FAILURE:
            return Object.assign({}, state, {uploading: false, uploadError: action.payload.error});
        case constants.MEDIA_DELETE_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.MEDIA_DELETE_SUCCESS:
            return Object.assign({}, state, {loading: false, error: null, invalid: true});
        case constants.MEDIA_DELETE_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});
    }
    return state;
}
